import React, { useState, useEffect } from "react";
import { AutoComplete } from 'primereact/autocomplete';

const SeleccionFormulariosNew = (props) => {
  const [selectedAutoValue, setSelectedAutoValue] = useState(null);
  const [autoFilteredValue, setAutoFilteredValue] = useState([]);
  const [autoValue, setAutoValue] = useState([]);
  const [reload, setReload] = useState(true);
  const [edita, setEdita] = useState(props.editar);
  const APITABLASBASICAS = 'https://www.ancogenecop.com/APIANCO/controllers/selecciones.php?op=';

  useEffect(() => {
    const traerUsuarios = async () => {
      const data = new FormData();
      try {
        const response = await fetch(APITABLASBASICAS + 'seleccionFormulariosNew', {
          method: 'POST',
          body: data
        });
        const result = await response.json();
        setAutoValue(result);

        // Asignar el valor inicial si se pasó por props
        if (props.TIDPROPIETARIO) {
          const encontrado = result.find(f => f.code === props.TIDPROPIETARIO);
          if (encontrado) setSelectedAutoValue(encontrado);
        }
      } catch (error) {
        console.error('Error al cargar formularios:', error);
      }
    };

    traerUsuarios();
  }, [reload, props.TIDPROPIETARIO]);

  const searchFormularios = (event) => {
    setTimeout(() => {
      if (!event.query.trim().length) {
        setAutoFilteredValue([...autoValue]);
      } else {
        setAutoFilteredValue(
          autoValue.filter((a) =>
            a.name.toUpperCase().startsWith(event.query.toUpperCase())
          )
        );
      }
    }, 250);
  };

  const handleChange = (event) => {
    setSelectedAutoValue(event);
    if (props.handleplanta !== undefined) {
      return props.handleplanta(event.code, 1);
    } else {
      return props.handleretorna(event.code, 1);
    }
  };

  return (
    <div className="p-error">
      {!edita ? (
        <AutoComplete
          placeholder="Buscar"
          id="dd"
          dropdown
          value={selectedAutoValue}
          onChange={(e) => handleChange(e.value)}
          suggestions={autoFilteredValue}
          completeMethod={searchFormularios}
          field="name"
        />
      ) : (
        <AutoComplete
          id="dd"
          dropdown
          value={selectedAutoValue}
          field="name"
          disabled
        />
      )}
    </div>
  );
};

export default SeleccionFormulariosNew;
